import * as React from 'react';
import {darken, lighten, alpha} from "@mui/material";
import { roundToNearestMinutes, format } from "date-fns";

// export const createDateAsUTC = (date) => {
//   return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
// }

// export const convertDateToUTC = (date) => { 
//   return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()); 
// }

// export const getDateToString = (date) => {
//   if (!(date instanceof Date) || isNaNnull(date)) return null;  
//   return `${date.getFullYear()}/${date.getMonth()+1}/${date.getDate()}T${date.getHours()}:${date.getMinutes()}`
// }

// export const getDateToUCTString = (date) => {
//   if (!(date instanceof Date) || isNaNnull(date)) return null;  
//   return `${date.getUTCFullYear()}/${date.getUTCMonth()+1}/${date.getUTCDate()}T${date.getUTCHours()}:${date.getUTCMinutes()}`
// }

export const getDateFromInt = (value) => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const t = d.getTime();
  return getValidDate(t + parseInt(value * 1000));
}

export const getIntFromDate = (dateTime) => {
  try {
    return 60 * 60 * dateTime.getHours() + 60 * dateTime.getMinutes() + dateTime.getSeconds();
  } catch(error) {
    console.log('...Bs4ColumnsTime...getFloat...', error);  
    console.log(error);      
  }
  return null;
}

export const getValidDate = (date) => {  
  if (!date && date !== 0) return null;
  if (isString(date)) {
    const dateT = date.trim();
    if (dateT.length <= 10) {
      date = dateT + ' 00:00';
      //console.log('...getValidDate...', dateT, date);
    }
  }
  const newDate = new Date(date);
  if (!(newDate instanceof Date) || isNullOrNaN(newDate)) return null;    
  return newDate;  
}

export const getValidDateFromTime = (time) => {
  if (!time) return null;
  const newDate = new Date('0001-01-01 '+time);
  if (!(newDate instanceof Date) || isNullOrNaN(newDate)) return null;  
  return newDate;  
}

export const toDateTimeStamp = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  let dateStr = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString();
  dateStr = dateStr.replace('T', ' ');
  dateStr = dateStr.replace('Z', '');
  return dateStr;  
}

export const toDateTime = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const dateStr = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString().split("T");
  const timeStr = dateStr[1].split('.');
  return dateStr[0]+' '+timeStr[0];
}

export const toDateMinutes = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const newDateMinutes = roundToNearestMinutes(newDate);
  const dateStr = new Date(newDateMinutes.getTime() - (newDateMinutes.getTimezoneOffset() * 60000 )).toISOString().split("T");
  const timeStr = dateStr[1].split('.');
  return dateStr[0]+' '+timeStr[0].substring(0, 5);
}

export const toDateTimeName = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const dateStr = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString();
  return dateStr.replaceAll(':', '_').replaceAll('.', '_').replaceAll('-', '_').replaceAll(' ', '_');  
}

export const toDate = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const dateStr = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString().split("T");

  return dateStr[0]
}

export const toTime = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const dateStr = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString().split("T");
  const timeStr = dateStr[1].split('.');
  return timeStr[0];
}

export const toTimeMinutes = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const dateStr = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000 )).toISOString().split("T");
  const timeStr = dateStr[1].split('.');
  const timeStrSec = timeStr[0].split(':');
  return timeStrSec[0]+':'+timeStrSec[1];
}

export const toTimeNoTimezone = (date) => {
  const newDate = getValidDate(date);
  if (!newDate) return '';
  const dateStr = new Date(newDate.getTime()).toISOString().split("T");
  const timeStr = dateStr[1].split('.');
  return timeStr[0];
}

export const toDateTimeSSS = (date) => {        
  try {
    return format(date, 'yyyy-MM-dd HH:mm:ss.SSS')
  } catch(error) {
    return '?';
  }  
};

export const isString = (value) => {
  return (typeof value === 'string' || value instanceof String)
}

export const getString = (value, defoult) => {
  if (isString(value)) return value;
  return defoult;
}

export const getNumber = (value, defoult) => {
  if (isNullOrNaN(value)) return defoult;
  return value;
}

export const isObject = (value) => {
  return (value && typeof value === 'object' && !Array.isArray(value) && !isString(value));
}

export class GroupObject {
  constructor() {
    this.groups = {}
  }

  add(type, object) {
    if (this.groups[type]) {
      this.groups[type].push(object);
    } else {
      this.groups[type] = [object];
    }
  }

  remove(object) {
    Object.keys(this.groups).forEach((key) => {
      this.groups[key] = this.groups[key].filter(storedObject => storedObject !== object)
    });
  }

  removeType(type) {
    delete this.groups[type];
  }

  get(types) {
    const group = [];
    if (!Array.isArray(types)) types = [types];        
    types.forEach(type => {      
      const subGroup =  this.groups[type];
      // console.log('...HideOnScroll...get group', type, subGroup);
      group.push(...(subGroup || []));
    })        
    return group;
  }
}

export class EventEmit {
  constructor() {
    this.events = {}
  }

  on(type, cb) {
    if (this.events[type]) {
      this.events[type].push(cb);
    } else {
      this.events[type] = [cb];
    }
  }

  off(cb) {
    Object.keys(this.events).forEach((key) => {
      this.events[key] = this.events[key].filter(eventListener => eventListener !== cb)
    });
  }

  trigger(type, ...args) {
    if (this.events[type]) {
      this.events[type].forEach(eventListener => {
        eventListener(...args);
      });
    } else {
      //console.log('== WARNING EventEmit trigger == no type:', type);
    }
  }
}

export class EventEmitArray {
  constructor() {
    this.events = {}
  }

  on(types, cb) {
    if (!Array.isArray(types)) types = [types];    
    types.forEach(type => {     
      type = String(type); 
      // console.log('...EventEmitArray... ON-ON', type, this.events);
      if (!type) {
        // console.log(new Error('...EventEmitArray... no type'), type, types);
        return;
      }
      if (this.events[type]) {
        this.events[type].push(cb);
      } else {
        this.events[type] = [cb];
      }
    })    
  }

  off(cb) {
    Object.keys(this.events).forEach((key) => {
      this.events[key] = this.events[key].filter(eventListener => eventListener !== cb)
    });
  }

  trigger(types, ...args) {
    if (types && !Array.isArray(types)) types = [types];
    let triggered = new Set();
     
    console.log('...EventEmitArray... ', types, this.events);
  
    if (types) types.forEach(type => {
      type = String(type);
      if (this.events[type]) {
        this.events[type].forEach(eventListener => {
          if (triggered.has(eventListener)) return;
          triggered.add(eventListener);
          eventListener(...args);
        });
      } else {
        //console.log('== WARNING EventEmit trigger == no type:', type);
      }
    });
    else  for (let [key, eventListeners] of Object.entries(this.events)) {
      eventListeners.forEach(eventListener => {
        if (triggered.has(eventListener)) return;
        triggered.add(eventListener);
        eventListener(...args);        
      });
    };
  }
}

export const getLastZIndex = (e) => {      
  if (!e?.parentNode) return 0;
  let z = parseInt(window.getComputedStyle(e).getPropertyValue('z-index'));
  z = isNullOrNaN(z) ? 0 : z
  let zp = parseInt(getLastZIndex(e.parentNode));
  zp = isNullOrNaN(zp) ? 0 : zp
  return z + zp; 
}

export const dragElement = (elmnt, header) => {
  if (!elmnt) { 
    return;
  }

  let startX = 0, startY = 0;
  let moveX = 0, moveY = 0

  if (header) {
    /* if present, the header is where you move the DIV from:*/
    header.onmousedown = dragMouseDown;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;    

    const rect = e.currentTarget.getBoundingClientRect();
    if (e.clientY - rect.y > 30) return;

    e.preventDefault();
    // get the mouse cursor position at startup:
    startX = e.clientX;
    startY = e.clientY;    
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    moveX = e.clientX - startX;
    moveY = e.clientY - startY;
    startX = e.clientX;
    startY = e.clientY;
    // set the element's new position:
    elmnt.style.top = (elmnt.offsetTop + moveY) + "px";
    elmnt.style.left = (elmnt.offsetLeft + moveX) + "px";
    //console.log('... dragElement .Down.', e)
  }

  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;
  }
}

export const useExternalScript = (url) => {
  let [state, setState] = React.useState(url ? "loading" : "idle");

  React.useEffect(() => {
    if (!url) {
      setState("idle");
      return;
     }

    let script = document.querySelector(`script[src="${url}"]`);

    const handleScript = (e) => {
      setState(e.type === "load" ? "ready" : "error");
    };

    if (!script) {
      script = document.createElement("script");
      script.type = "application/javascript";
      script.src = url;
      script.async = true;
      document.body.appendChild(script);
      script.addEventListener("load", handleScript);
      script.addEventListener("error", handleScript);
    }

   script.addEventListener("load", handleScript);
   script.addEventListener("error", handleScript);

   return () => {
     script.removeEventListener("load", handleScript);
     script.removeEventListener("error", handleScript);
   };
  }, [url]);

  return state;
};

export const loadExternalScript = (url, handleScriptCaller) => {
  if (!url) return;

  const handleScript = (e) => {
    script.removeEventListener("load", handleScript);
    script.removeEventListener("error", handleScript);
    handleScriptCaller(e);
  }

  let script = document.querySelector(`script[src="${url}"]`);

  if (!script) {    
    script = document.createElement("script");    
    script.type = "application/javascript";
    script.src = url;
    script.async = true;
    document.body.appendChild(script);    
  }

   script.addEventListener("load", handleScript);
   script.addEventListener("error", handleScript);
};

export const getBs4Style = (bs4StyleStr, empty) => {
  if (bs4StyleStr) {
    try {
      let bs4Style = JSON.parse(bs4StyleStr)
      if (bs4Style && typeof bs4Style === 'object' && !Array.isArray(bs4Style)) return bs4Style;
    } catch(error) {
      console.log('...getBs4Style..error..str:', bs4StyleStr)
      console.log('...getBs4Style..error:', error)
      return empty || null;
    }
  }
  return empty || null;
}

export const colorToRgba = (color) => {
  let colorRgba = null;
  let cccc = null;
  try {
    color = color.trim().toLocaleLowerCase()
    if (color.startsWith('#')) {
      if (color.length === 4) {
        colorRgba = {
          r: parseInt(color.slice(1, 2), 16) * 17,
          g: parseInt(color.slice(2, 3), 16) * 17,
          b: parseInt(color.slice(3, 4), 16) * 17,
          a: 1,
        }  
      } else if (color.length === 7) {
        colorRgba = {
          r: parseInt(color.slice(1, 3), 16),
          g: parseInt(color.slice(3, 5), 16),
          b: parseInt(color.slice(5, 7), 16),
          a: 1,
        }
      } else if (color.length === 9) {
        colorRgba = {
          r: parseInt(color.slice(1, 3), 16),
          g: parseInt(color.slice(3, 5), 16),
          b: parseInt(color.slice(5, 7), 16),
          a: parseFloat(parseInt(color.slice(7, 9), 16) / 255),
        }
      } else {
        throw new Error('Incorrect color format');
      }
    } else if (color.startsWith('rgba')) {
      cccc = color.replace('rgba', '').replace('(', '').replace(')', '').split(',');
      if (cccc.length === 4) colorRgba = {
        r: parseInt(cccc[0]),
        g: parseInt(cccc[1]),
        b: parseInt(cccc[2]),
        a: parseFloat(cccc[3]),
      }
    } else if (color.startsWith('rgb')) {
      cccc = color.replace('rgb', '').replace('(', '').replace(')', '').split(',');
      if (cccc.length === 3) colorRgba = {
        r: parseInt(cccc[0]),
        g: parseInt(cccc[1]),
        b: parseInt(cccc[2]),
        a: 1,
      }
    } else {
      throw new Error('Incorrect color format');
    }
  } catch (error) {
    // console.log('=== Error === colorToRgba ===', color, error);
    return null
  }  

  return colorRgba
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

export const colorToHex = (color) => {
  const colorRgba = colorToRgba(color);
  return "#" + componentToHex(colorRgba.r) + componentToHex(colorRgba.g) + componentToHex(colorRgba.b);
}

export const getColorLuminosity = (color) => {
  try{ 
    const colorRgba = colorToRgba(color);
    return colorRgba.r + colorRgba.g + colorRgba.b;
  } catch (error) {
    // console.log('...getColorLuminosity..,error...', color, colorToRgba(color));
    // console.log('...getColorLuminosity..,error...', error);
    return null;
  }
}

export const geolocation = () => {
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };
  
  function success(pos) {
    const crd = pos.coords;
  
    console.log("Your current position is:", pos);
    console.log(`Latitude : ${crd.latitude}`);
    console.log(`Longitude: ${crd.longitude}`);
    console.log(`More or less ${crd.accuracy} meters.`);
  }
  
  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }
  
  navigator.geolocation.getCurrentPosition(success, error, options);
}

export const isNullOrNaN = (value) => value === null || isNaN(value);

export function shallowEqual(object1, object2, text) {
  try{
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      console.log(text+' length', object1, object2)
      return false;
    }

    let eq = true;
    for (let key of keys1) {
      if (object1[key] !== object2[key]) {      
        console.log(text+' key', key, object1[key], object2[key]);
        eq = false;
      }
    }
    return eq;
  } catch(error) {
    console.log(text+' error', object1, object2 )
    return false;
  }
}

export function colorIsDark(color) {
  const colorRGB = alpha(color, 1).replace('rgba', '').replace('(', '').replace(')', '');
  const [rs, gs ,bs , ...as] = colorRGB.split(',');
  const r = parseInt(rs);
  const g = parseInt(gs);
  const b = parseInt(bs);
  const uicolors = [r / 255, g / 255, b / 255];
  const c = uicolors.map((col) => {
    if (col <= 0.03928) return col / 12.92;
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  const L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
  return L
  //return [L, L <= 0.179];
}